import styled from "styled-components";
import cssVars from "../../../../styles/cssVariables.vars";

export const StyledMyAttendancesMenu = styled.div`
    grid-area: mbody;

    display: grid;
    grid-template-areas: 
    "isearch"
    "results"
    "pagination";

    grid-template-columns: 100%;
    grid-template-rows: max-content 1fr max-content;
    height: 100%;

    >.filter{
        grid-area: 'isearch';
        height: max-content;
        display: flex;
        flex-direction: column;
        padding: 0.5rem;

        button {
            font-size: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            cursor: pointer;
            padding: 1rem 0;
            font-weight: 600;
            color: ${cssVars.colorGrey[3]};

            :hover {
                background-color: rgba(255, 0, 0, 0.05);
            }
        }
    }

    >.results{
        grid-area: 'results';
        overflow: auto;
        height: auto;
        padding: 0 0.5rem;
    }

    .page-navigation {
        grid-area: 'pagination';
        margin: 0px auto;
        height: auto;
        padding: 1rem 0;
        width: 100%;
        display: flex;
        justify-content: center;
        border-top: 1px solid ${cssVars.colorGrey[4]};
       
        button {
            color: ${cssVars.colorGrey[2]};
        }
    }
`;